import styled from "styled-components"

import theme from '../../../styles/theme';
import { MyResponsiveBar, MyResponsivePie } from '../../SampleChart';
import React from 'react';
import { TableStyle } from '../../../styles/common';


const Card = styled.div`
    background: ${theme.color.primary.main};
    border-radius: 16px;
    // border: 2px solid ${theme.color.primary};
    border: 0.5px solid ${theme.color.black[10]};
    padding: 1rem;
    // box-shadow: ${theme.color.shadow};
    transition: all 400ms ease-in-out, transform 400ms ease-in-out;
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        width: calc(100% - 24px);
        margin: 0;
        
        color: ${theme.color.black};
    }
    div {
        // width: calc(100% - 24px);
        // padding: 12px;
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    &:hover {
        background: ${theme.color.primary.pupple};
        box-shadow: ${theme.color.shadow};
    }
`;

const Home = () => {
    
    return (
        <React.Fragment>
            <div style={{width:'calc(100% - 2rem)', padding:'1rem 1rem', display:'grid',columnGap:'1.5rem', gridTemplateColumns: '1fr 1fr'}}> 
                    <Card>
                        <div style={{display:'flex',alignItems:'center'}}><h3>Sample Chart1</h3><img src={`/images/ic_detail.svg`}/></div>
                        <div style={{height:'14rem'}}>
                        <MyResponsiveBar />
                        </div>
                    </Card>
                    <Card>
                        <h3>Sample Chart2</h3>
                        <div style={{height:'14rem'}}>
                        <MyResponsivePie />
                        </div>
                    </Card>
                </div>
                <div style={{width:'calc(100% - 2rem)', padding:'0rem 1rem'}}> 
                    <Card>
                        <h3>Sample List</h3>
                        <TableStyle>
                            <div className="header">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                            <div className="row">
                                <span>No</span>
                                <span>내용1</span>
                                <span>내용2</span>
                                <span>내용3</span>
                                <span>내용4</span>
                                <span>내용5</span>
                            </div>
                        </TableStyle>
                    </Card>
                </div>
        </React.Fragment>
    )
}

export default Home;